import Layer, { Result } from './Layer.js';

import { SensorDataManager } from '@data/Simulations/RawSensorDatas.js';
import { SimulationSet } from '../data/SimulationSet';
import { Frame } from './Frame.js';
import Grid from 'Geodata/grid.js';
import FVector from '@data/geometry/FVector.js';
type SimulationKinds = 0 | 1 | 2 | 4 | 8 | 16 | 32 | 64 | 128 | 256;

class EmptyLayer extends Layer {
    name: string;

    protected readonly simKind: SimulationKinds = 1;
    constructor(parentSimulationSet: SimulationSet, UID: string) {
        super(parentSimulationSet, UID);

        this.name = 'Empty Layer';

        this.parentSimulationSet = parentSimulationSet;
        const values = new Float32Array(Grid.sensorPointsN).fill(0);
        const directions = Array.from({ length: Grid.sensorPointsN }, () => new FVector());
        const actualFrame = new Frame(this, 'Empty Frame', new SensorDataManager(values, directions));

        const result: Result = {
            unitOfMeasure: 'No',
            resultLabel: '-',
            resultId: 0,
            frameCollection: [actualFrame],
        };
        this.results.push(result);
    }
}

export default EmptyLayer;
